<template>
        <b-col sm="12"
               class="map-list-wrapper"
               :class="{movedByRightPanel: currentDamSelected}"
        >
            <keep-alive>
                <MapDams
                    v-if="isMapActive"
                    :data="filteredDataMap"
                ></MapDams>
            </keep-alive>
            <TableOverview
                v-if="isListActive"
                :data="getFilteredPsData"
            ></TableOverview>
        </b-col>

</template>

<script>
    // vuex
    import {GET_PS_DATA, SET_ACTIVE_STATION, SET_INFO_WINDOW_OPEN} from "../../store/actions/dashboard";
    import {mapActions, mapGetters} from "vuex";
    // constants
    import {UPDATE_DASHBOARD_INTERVAL} from "../../constants/general-constants";
    // components
    import MapDams from "./MapDams";
    import TableOverview from "./TableOverview";

    /**
     * Wrapper for the map and the table,
     * which share the same data.
     * Fetch data on creation.
     * On mounted, set a interval to update
     * the date with AJAX calls to the server.
     */

    export default {
        name: "MapTableWrapper",
        components: {
            MapDams,
            TableOverview
        },
        data() {
            return {
                updateInterval: null
            }
        },
        created() {
            this.$store.dispatch(GET_PS_DATA);
        },
        mounted() {
            this.updatePsData();
            this.updateActiveStationIfPrevious();
        },
        computed: {
            ...mapGetters([
                'currentDamSelected',
                'isMapActive',
                'isListActive',
                'getPsData',
                'getPsStatusFilters',
                'getFilteredPsData',
                'getDamData'
            ]),
            /**
             * Apply a status filtering, done by
             * using the legend check marks.
             */
            filteredDataMap() {
                if (this.getPsData['PS_stations']) {
                    const filtered = this.getPsData['PS_stations']
                        .filter(item => this.getPsStatusFilters.includes(item[4].toString()));

                    return {
                        ...this.getPsData,
                        PS_stations: filtered
                    }
                }
                return this.getPsData;
            }
        },
        methods: {
            ...mapActions([
                SET_ACTIVE_STATION,
                SET_INFO_WINDOW_OPEN
            ]),
            /**
             * Fetch data for the stations. Used by timer.
             */
            async dispatchUpdate() {
                return await this.$store.dispatch(GET_PS_DATA);
            },
            /**
             * This method actually sets an update interval
             * which calls the dispatchUpdate every 10 seconds.
             * @returns {Promise<void>}
             */
            async updatePsData() {
                this.updateInterval = setInterval( this.dispatchUpdate , UPDATE_DASHBOARD_INTERVAL);
            },
            updateActiveStationIfPrevious() {
                if (this.getDamData && this.getDamData.asList) {
                    this.SET_ACTIVE_STATION(this.getDamData.asList);
                    this.SET_INFO_WINDOW_OPEN();
                }
            }
        },
        beforeDestroy() {
            // clear the interval as to stop getting data
            clearInterval(this.updateInterval);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    /* Changing the padding is done as animation */
    .map-list-wrapper {
        transition: padding-right .6s;
        padding: 0;
        &.movedByRightPanel {
            padding-right: 395px;
        }
    }

    @media (max-width: 768px) {
        .map-list-wrapper {
            &.movedByRightPanel {
                padding-right: 100%;
            }

        }
    }
</style>